import React, { useState } from 'react';
import { Link } from 'react-router';
import Status from './Status';

const HomeScreen = ({
  nextEval: {
    id: nextEvalId,
  } = {},
  lang = {},
  customWelcomeText,
  status,
  pointsPerStatement,
  user
}) => {
  
  const nextText = nextEvalId !== 'end' ?
    <Link to={`/q/${nextEvalId}/1`}>
      <button>{lang.q360_home_start}</button>
    </Link> :
    lang.q360_home_finished_choose;

  return (
    <div class='col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 col-xs-10 col-xs-offset-1 fadeIn animated'>
      <h1>{lang.q360_home_title}</h1>
      { nextEvalId !== 'end' &&
        <div class='col-md-12 col-sm-12 col-xs-12 center mar40'
          dangerouslySetInnerHTML={{ __html: customWelcomeText }} />
      }
      <Status
        lang={ lang }
        status={ status }
        pointsPerStatement={ pointsPerStatement }
        user={ user }
      />
      <div class='col-md-12 col-sm-12 col-xs-12 center mar20'>
        {nextText}
      </div>
    </div>
  );
}

export default HomeScreen;
